import AskedQuestions from './AskedQuestions';

function ChatContent() {
  return (
    <div className="flex-1 space-y-4 overflow-auto my-2 p-0">
      <AskedQuestions />
    </div>
  );
}

export default ChatContent;
